import { Injectable, signal } from '@angular/core';

export type ThemeMode = 'dark' | 'light';

/** Signal-based replacement for Consumer's Redux `themeSlice`. */
@Injectable({ providedIn: 'root' })
export class ThemeStore {
  readonly mode = signal<ThemeMode>('dark');

  setMode(mode: ThemeMode): void {
    this.mode.set(mode);
    this.applyThemeClass(mode);
  }

  toggle(): void {
    this.setMode(this.mode() === 'dark' ? 'light' : 'dark');
  }

  applyThemeClass(mode: ThemeMode): void {
    const root = document.documentElement;
    root.classList.toggle('light', mode === 'light');
  }
}
